import { Menu, PhoneCall,X } from 'lucide-react';
import React, { useState } from 'react';
import logo from '../../Assets/RDS ENCLAVE@300x-8.png';
import slide from '../../Assets/original/ARN_3208.JPG';
import about from '../../Assets/about-1.jpg';
// import { PhoneCall, Menu, X } from 'lucide-react';
import dir from "../../Assets/portrait-businessman-arm-crossed-white-isolated-background.png"

import { MdOutlineKeyboardDoubleArrowRight } from "react-icons/md";
import Recognized from '../UI/Recognized';
import Footer from '../UI/Footer';
import slide1 from '../../Assets/original/ARN_3202.JPG';
import { Link } from 'react-router-dom';
import ContactModal from '../UI/ContactModal';

const About = () => {
  const [showMoreJourney, setShowMoreJourney] = useState(false);
  const [showMoreGroup, setShowMoreGroup] = useState(false);
  const slides = [slide1];
  const [menuOpen, setMenuOpen] = useState(false);
    const [showContactModal, setShowContactModal] = useState(false);
  
  return (
    <div>
      {/* Top Fullscreen Banner */}
      <div
    className="relative md:h-screen h-[130px] bg-cover bg-center bg-no-repeat transition-all duration-1000" 
        style={{ backgroundImage: `url(${slide})` }}
      >
      <header className="absolute top-0 left-0 w-full flex justify-between items-center p-2 z-50">
          {/* Logo */}
          <Link to="/">
            <img src={logo} alt="Logo" className="h-12 sm:h-24 w-auto md:block hidden" />
          </Link>

          {/* Right Nav */}
          <div className="flex items-center gap-3 sm:gap-4 text-white">
            {/* Desktop Links */}
            <div className="hidden sm:flex items-center gap-4">
                <Link to="/">
                <button className="text-black font-medium text-lg">Home</button>
              </Link>
              <Link to="/about">
                <button className="text-black font-medium text-lg">About Us</button>
              </Link>
              <Link to="/projects">
              <button className="text-black font-medium text-lg">Our Projects</button>
            </Link>
              <button
              onClick={() => setShowContactModal(true)}
              className="text-black font-medium text-lg border border-black px-4 py-1 rounded hover:bg-black hover:text-white"
            >
              Contact Us
            </button>
            </div>

            {/* Call Icon */}
            {/* <div className="w-7 h-7 sm:w-10 sm:h-10 rounded-full bg-white/20 border border-black flex items-center justify-center hover:bg-white/30">
              <PhoneCall className="text-black h-5 w-5 md:h-7 md:w-7"  />
            </div> */}
       {/* <div className="w-9 h-9 sm:w-10 sm:h-10 rounded-full bg-white/20 border border-black flex items-center justify-center hover:bg-white/30  sm:hidden">
              <Menu className="text-black" size={20} />
            </div> */}
            {/* Menu Icon (Mobile) */}
            <div
              className="w-7 h-7 sm:w-10 sm:h-10 rounded-full bg-white/20 border border-black flex items-center justify-center hover:bg-white/30 sm:hidden"
              onClick={() => setMenuOpen(!menuOpen)}
            >
              {menuOpen ? <X className="text-black" size={20} /> : <Menu  className="text-black h-5 w-5 md:h-12 md:w-12" />}
            </div>
          </div>
        </header>
      </div>

      {/* Breadcrumb */}
      <div className='flex max-w-screen-lg mx-auto mt-4 px-4 items-center'>
     <Link to="/">
     <span className='font-medium text-sm sm:text-md text-gray-400'>Home</span>
        </Link>
        <MdOutlineKeyboardDoubleArrowRight className='mx-1 text-gray-500' size={20} />
        <span className='font-semibold text-sm sm:text-md'>About Us</span>
      </div>
    {menuOpen && (
        <div className="absolute top-20 right-4 bg-white text-black shadow-md rounded-lg py-2 w-48 z-50 sm:hidden">
          <Link to="/about" className="block px-4 py-2 hover:bg-gray-100" onClick={() => setMenuOpen(false)}>
            About Us
          </Link>
          <Link to="/projects" className="block px-4 py-2 hover:bg-gray-100" onClick={() => setMenuOpen(false)}>
            Our Projects
          </Link>
          <button className="block w-full text-left px-4 py-2 hover:bg-gray-100" onClick={() => {
            setShowContactModal(true);
            setMenuOpen(false);
          }}>
            Contact Us
          </button>
        </div>
      )}

      {/* Contact Modal */}


      <ContactModal isOpen={showContactModal} onClose={() => setShowContactModal(false)} />
        
      {/* The RDS Enclave Group */}
      <section className="bg-white py-12 px-4 sm:px-6 md:px-20 lg:px-32 text-center text-gray-800">
        <div className="flex flex-col sm:flex-row items-center justify-center py-6 space-y-4 sm:space-y-0 sm:space-x-6">
          <div className="w-40 sm:w-72 h-0.5 bg-gray-300"></div>
          <h2 className="text-xl sm:text-2xl font-bold">THE RDS ENCLAVE GROUP</h2>
          <div className="w-40 sm:w-72 h-0.5 bg-gray-300"></div>
        </div>

        <p className="text-base sm:text-lg max-w-4xl mx-auto leading-relaxed mb-4">
          Established in 2024, RDS Enclave started with a vision to redefine urban living with thoughtful and eco-friendly spaces. Founded by passionate entrepreneurs, our journey began with a single project that sparked a revolution in residential design.
        </p>

        {showMoreGroup && (
          <p className="text-base sm:text-lg max-w-4xl mx-auto leading-relaxed">
            Today, we’re proud to serve families and communities across the region with homes built on trust, design excellence, and unmatched quality. Our footprint is growing — and so is our commitment to building a better tomorrow through innovation, sustainability, and customer delight.
          </p>
        )}

        <button onClick={() => setShowMoreGroup(!showMoreGroup)} className='underline mt-5 text-blue-600'>
          {showMoreGroup ? 'Read Less' : 'Read More'}
        </button>
      </section>

      {/* Feature Image */}
      <div
        className="h-[60vh] sm:h-[78vh] bg-cover bg-center bg-no-repeat transition-all duration-1000"
        style={{ backgroundImage: `url(${slides[0]})` }}
      ></div>

      {/* Our Journey */}
      <section className="bg-white py-12 px-4 sm:px-6 md:px-20 lg:px-32 text-center text-gray-800">
        <div className="flex flex-col sm:flex-row items-center justify-center py-6 space-y-4 sm:space-y-0 sm:space-x-6">
          <div className="w-40 sm:w-72 h-0.5 bg-gray-300"></div>
          <h2 className="text-xl sm:text-2xl font-bold">OUR JOURNEY</h2>
          <div className="w-40 sm:w-72 h-0.5 bg-gray-300"></div>
        </div>

        <h3 className='text-gray-700 text-lg sm:text-2xl font-sans mb-6'>
          “RDS Enclave has redefined living experiences and continues to set new benchmarks in the real estate sector.”
        </h3>

        <p className="text-base sm:text-lg leading-relaxed mb-4 max-w-4xl mx-auto">
          Since its inception in 2024, RDS Enclave has been committed to crafting exceptional spaces that combine innovative design, sustainable practices, and a passion for excellence.
        </p>

        {showMoreJourney && (
          <p className="text-base sm:text-lg max-w-4xl mx-auto leading-relaxed">
            With every project, we bring together cutting-edge technology and timeless quality to meet the evolving needs of modern families. Our journey is marked by trust, integrity, and a customer-first approach.
          </p>
        )}

        <button onClick={() => setShowMoreJourney(!showMoreJourney)} className='underline mt-5 text-blue-600'>
          {showMoreJourney ? 'Read Less' : 'Read More'}
        </button>
      </section>

      {/* The Purpose of Joy */}
      <section className="bg-white py-12 px-4 sm:px-6 md:px-20 lg:px-32">
        <div className="flex flex-col sm:flex-row items-center justify-center py-6 space-y-4 sm:space-y-0 sm:space-x-6 text-center">
          <div className="w-40 sm:w-72 h-0.5 bg-gray-300"></div>
          <h2 className="text-xl sm:text-2xl font-bold text-gray-800">THE PURPOSE OF JOY</h2>
          <div className="w-40 sm:w-72 h-0.5 bg-gray-300"></div>
        </div>

        <div className="flex flex-col lg:flex-row gap-6 items-center justify-center">
          <div className="w-full lg:w-1/2">
            <img src={about} alt="about" className="w-full h-auto rounded" />
          </div>
          <div className="w-full lg:w-1/2 text-gray-700 text-base sm:text-lg leading-relaxed">
            <p className='mb-4'>
              We create spaces that enable Everyday Joys; one community, one family, and one home at a time.
            </p>
            <p>
              The joy we bring to neighborhoods, families, and our customers drives our purpose forward. It's at the forefront of every decision we make, as we strive to work in harmony with all stakeholders to achieve the shared goal of 'Creating Customer Joy'.
            </p>
          </div>
        </div>
      </section>
   {/* Directors Section */}
<section className="bg-white py-12 px-4 sm:px-6 md:px-20 lg:px-32">
  <div className="flex flex-col sm:flex-row items-center justify-center py-6 space-y-4 sm:space-y-0 sm:space-x-6 text-center">
    <div className="w-40 sm:w-72 h-0.5 bg-gray-300"></div>
    <h2 className="text-xl sm:text-2xl font-bold text-gray-800">MEET OUR DIRECTORS</h2>
    <div className="w-40 sm:w-72 h-0.5 bg-gray-300"></div>
  </div>

  {/* Card Grid */}
  <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 justify-items-center mt-10">
    {[
      { name: 'Mr. name1', position: 'Founder & CEO', image: dir },
      { name: 'Mrs. name2', position: 'Director – Operations', image: dir },
      { name: 'Mr. name3', position: 'Head – Project Development', image: dir }
    ].map((person, index) => (
      <div key={index} className="relative bg-gray-100 border border-gray-200  overflow-hidden w-96">
        {/* Name & Position */}
        <div className="absolute bottom-0 left-0 w-full bg-black bg-opacity-40 text-white p-2 text-center z-10">
          <p className="font-semibold text-md">{person.name}</p>
          <p className="text-sm">{person.position}</p>
        </div>
        {/* Profile Image */}
        <img src={person.image} alt={person.name} className="w-full h-96 object-cover" />
      </div>
    ))}
  </div>
</section>

      {/* <Recognized /> */}
      <Footer />
    </div>
  );
};

export default About;
